// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon[data-v-7837b2c6]{margin-bottom:.125rem}.field[data-v-7837b2c6]{align-items:center;display:inline-flex;gap:.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
